import { mapState } from "vuex";
import { app_version, get_scroll_offset } from "./tool";
import { GET_SESSION_USER } from "@/api/config";
import _this from "@/main";

function permission_list(all_list = [], plan_sale_list = [], is_crm = false, is_sub = false){
    let list = [
        { name: _this.$t('c.mixin.text1'), value: "public" },
        { name: _this.$t('c.mixin.text2'), value: "0.00" },
    ];
    if(is_crm){
        list.push({ name: _this.$t('c.mixin.text3'), value: "all", plan_id:'all' })
        list.push({ name: _this.$t('c.mixin.text4'), value: "-1", plan_id:'-1' })
    }
    if(is_sub){
        list = [
          { name: _this.$t('c.mixin.text5'), value: "0.00", plan_id:'all'},
          { name: _this.$t('c.mixin.text14'), value: "0.00", plan_id:'all-include-independent'}
        ]
    }
    all_list.forEach((v, k) => {
        let is_season_year = v.pay_month == 3 || v.pay_month == 12;
        if (v.price > 0) {
            let limit = 30;
            let name = `${v.permanent ? _this.$t('c.mixin.text6') : v.independent ? _this.$t('c.mixin.text7'): ""} ￥${is_season_year ? (v.show_price_after_adjust || v.show_price) : v.price}${[1,2,3].indexOf(v.product_type) != -1 ? (v.product_type == 1 ? _this.$t('c.mixin.text8') : '') : ''}${[1,2,3].indexOf(v.product_type) == -1 && !v.independent && !is_season_year ? _this.$t('c.mixin.text9') : ""}${v.pay_month == 3 ? _this.$t('c.mixin.text10') : ""}${v.pay_month == 12 ? _this.$t('c.mixin.text11') : ""}${v.name ? " - " + v.name : ""}`;
            name = name.length > limit ? name.substring(0, limit) : name;
            list.push({
                name: name,
                value: v.price,
                plan_id: v.plan_id,
            });
        }
    });
    if(plan_sale_list.length > 0){
        plan_sale_list.forEach(v => {
            if(v.sku){
                v.sku.forEach(item => {
                    if(item.album && item.album.album_id){
                        list.push({
                            name: `${_this.$t('c.mixin.text12')} ¥ ${v.price} ${v.name} - ${item.name}${_this.$t('c.mixin.text13')}`,
                            value: v.price,
                            album_ids: item.album.album_id
                        });
                    }
                })
            }
        })
    }
    // if(is_sub){
    //     list = list.filter(v => v.independent != 1 && v.product_type != 1)
    // }
    return list
}
export default {
    data: function () {
        return {
            _lock_body_top: 0,
            mixin_scroll_busy: false,
        };
    },
    computed: {
        ...mapState("app", [
            "session_user",
            "browser_size",
            "bind_account",
            "plan_list",
            'black_list',
            "plan_sale_list",
            "host",
            "is_applying_apple",
            "is_applying_google",
        ]),
        is_creator() {
            if (
              this.session_user &&
              this.session_user.creator &&
              this.session_user.creator.status
            ) {
              return true;
            }
            return false;
        },
        mixin_is_safe_space(){
            return{
                action_sheet: this.GL.ENV.is_afd_client && this.GL.ENV.is_ios && ['']
            }
        },
        // mixin_is_show_wechat_open_app(){
        //     let config = [
        //         // "pPostId",
        //         // 'albumAlbumId',
        //         // 'groupGroupId',
        //         'testxxx',
        //         'index',
        //     ];
        //     return (
        //         this.GL.ENV.is_wechat && config.indexOf(this.$route.name) != -1 && this.session_user && (this.session_user.user_id == '179f19102e7111e8bf4d52540025c377' || this.session_user.user_id == 'efe23e54eca511e8a81f52540025c377')
        //     );
        // },
        mixin_is_show_tab_nav() {
            let config = [
                "feed",
                "explore",
                "message",
                "myDashboard",
                "dashboardStats",
                "dashboardSponsored-bill",
                "dashboardSponsors",
                "dashboardIncome",
                "dashboardMark",
                "dashboardMark-post",
                "dashboardOrder",
                'dashboardSponsoring'
            ];
            if (this.session_user) {
                if (
                    this.session_user.creator &&
                    !this.session_user.creator.status
                ) {
                    config[4] = "dashboardSponsoring";
                }
                config.push("index");
            }
            return (
                config.indexOf(this.$route.name) != -1 &&
                !this.GL.ENV.is_afd_client
            );
        },
        mixin_is_hide_tip_toast() {
          let list = [
              'oauth2',
              'app',
          ];
          return (
              list.indexOf(this.$route.name) != -1
          );
        },
        mixin_is_show_nav_menu_client() {
            let list = [
                'dashboardSponsoring',
                'dashboardStats',
                "dashboardSponsored-bill",
                "dashboardMark-post",
                "dashboardSponsors",
                "dashboardIncome",
                "dashboardMark",
                "dashboardOrder",
            ];
            if(this.GL.ENV.is_afd_client && list.indexOf(this.$route.name) != -1){
              if(this.GL.ENV.is_ios && app_version("1.3.14") == "higher" && !this.is_applying_apple){
                return true
              }
              if(this.GL.ENV.is_android && app_version("0.0.41") == "higher"){
                return true
              }
              if(this.GL.ENV.is_android && !this.is_applying_google){
                return true
              }
            }
            return false
        },
        mixin_is_show_nav_stack_mobile() {
            let list = [
                "apply",
                "item",
                "bundle",
                "bind",
                "search",
                "oauth2",
                "forgot",
                "uUserId",
                "aSlug",
                "aSlugPlan",
                "aSlugThank",
                // "aSlugAlbum",
                "pPostId",
                "messageUserId",
                "myBill",
                "settingAccount",
                "settingPlan",
                "settingCreator",
                "settingPayment",
                "settingGoal",
                "settingRejectlist",
                "settingBlocklist",
                "settingNotification",
                "settingBadge",
                "settingIdentity",
                "settingContacts",
                "orderCreate",
                "noticeComment",
                "noticeLike",
                "about",
                "term",
                "itemPurchase",
                "settingRedeem",
                "redeemRedeemId",
                "editAlbum",
                "editShop",
                // "editArticle",
                "groupGroupId",
                "albumAlbumId",
                "albumAlbumIdPostId",
                // "dashboardSponsored-bill",
                // "dashboardSponsors",
                // "dashboardIncome",
                // "dashboardMark",
                // "dashboardOrder",
                "dashboardDev",
                "applyCertify",
                "cashier",
            ]
            let ver_1 = this.GL.ENV.is_android && app_version("0.0.37") == "higher" || this.GL.ENV.is_ios && app_version("1.3.19") == "higher";
            if(this.$route.name == 'messageUserId' && ver_1){
                return true;
            }
            return (
                list.indexOf(this.$route.name) != -1 &&
                !this.GL.ENV.is_afd_client &&
                // !(this.GL.ENV.is_ios && app_version("1.3.19") == "lower") && !(this.GL.ENV.is_android && app_version("0.0.39") == 'lower') &&
                !this.GL.ENV.is_wechat_mini
            );
        },
        mixin_is_aricle_edit() {
            return (
                ["editArticle", "leaflet", "app", "link"].indexOf(
                    this.$route.name
                ) != -1
            );
        },
        mixin_is_show_nav_header_mobile() {
            return (
                ["compose"].indexOf(this.$route.name) == -1 &&
                !this.mixin_is_show_nav_stack_mobile &&
                !this.mixin_is_aricle_edit &&
                !this.GL.ENV.is_afd_client &&
                !this.GL.ENV.is_wechat_mini
            );
        },
        mixin_is_nav_icon_avatar() {
            return (
                [
                    "dashboardSponsored-bill",
                    "dashboardSponsors",
                    "dashboardIncome",
                    "dashboardSponsoring",
                    "dashboardMark",
                    "dashboardOrder",
                    "dashboardDev",
                    "dashboardStats",
                ].indexOf(this.$route.name) == -1
            );
        },
        mixin_is_bind_session_user() {
            return (
                this.bind_account.email != "" || this.bind_account.phone != ""
            );
        },
        mixin_permission_list() {
          return permission_list(this.plan_list, this.plan_sale_list);
        },
        mixin_permission_all_list() {
          return permission_list(this.plan_list.concat(this.plan_sale_list));
        },
        mixin_permission_sponsored_all_list() {
          let list = permission_list(this.plan_list.concat(this.plan_sale_list))
          list.splice(2,0,{ name: "自选金额", value: "-1", plan_id:'-1' })
          return list;
        },
        mixin_permission_crm_all_list() {
            return permission_list(this.plan_list.concat(this.plan_sale_list), [], true);
        },
        mixin_permission_crm_list() {
            let list = permission_list(this.plan_list.concat(this.plan_sale_list));
            let list2 = [];
            list.forEach(v => {
                if(v.plan_id){
                    list2.push[{
                        name:v.name,
                        value:v.plan_id,
                    }]
                }
            })
            return list2;
        },
    },
    watch: {},
    methods: {
        mixin_permission_group_list(list_pre){
          let list = permission_list(list_pre)
          if(list_pre.length == 0){
            list = [{name: '你还没有赞助方案，去新建 →', value: -1, can_jump:'/setting/plan'}]
          }
          else {
            list.shift()
            list[0].plan_id = 'all'
          }
          
          return list;
        },
        mixin_permission_sub_list(list) { //只含会员的订阅
            return permission_list(list, [], false, true);
        },
        mixin_lock_scroll(is_lock_top = false) {
          let offset = get_scroll_offset()
            this._lock_body_top = offset.y
            if(is_lock_top){ //为了向前兼容
              document.querySelector('body').setAttribute('style', `top: -${this._lock_body_top}px`)
            }                
            document.body.setAttribute("class", "lock-scroll");
        },
        mixin_unlock_scroll(is_lock_top = false) {
            // document.body.cssText = `top: 'auto'; height: 'auto'`
            if(is_lock_top){ //为了向前兼容
              document.querySelector('body').removeAttribute('style')
            }           
            document.body.setAttribute("class", "");
            document.documentElement.scrollTop = this._lock_body_top;
            document.body.scrollTop = this._lock_body_top;
        },
        mixin_go_login(path = '') {
            this.$store.commit("app/set:redirect_url", path || this.$route.fullPath);
            this.$router.push({ name: "login" });
        },
        mixin_scroll_load_more() {
            // this.$store.commit('app/set:is_scroll_load', true);
            // console.log('root_scroll')
            this.$bus.$emit("SCROLL_LOAD_MORE");
            this.$bus.$emit("SCROLL_LOAD_MORE_FEED");
        },
        async $mixin_check_post_permission(post = {}){
            let re = await this.$mixin_waitting_api(GET_SESSION_USER)
            if(re && !this.session_user && post.user && (post.user.is_verified != 1 || post.user.is_not_rec != 0)){
                this.$store.commit("app/set:redirect_url", location.pathname);
                this.$router.push("/login");
                return false;
            }
            if(post && post.jump_home){
                this.$router.replace(`/a/${post.user.url_slug}`);
                return false;
            }
            if (re && this.session_user && post) {
                if (
                    this.is_applying_apple &&
                    this.black_list.POSTS.indexOf(this.post_id) != -1
                ) {
                    //审核的人黑名单文章不能看
                    this.$router.push("/feed");
                    return false;
                }
            }
            return true
        },
        mixin_copy(text, param = {}, callback) {
            let _this = this;
            this.$copyText(text).then(
                function (e) {
                    _this.$notify({
                        title: param.text || "已复制",
                        group: "success",
                    });
                    if (callback) {
                        callback(e);
                    }
                },
                function (e) {
                    _this.$notify({
                        title: "当前浏览器不支持复制，请手动自行复制",
                        group: "error",
                    });
                    if (callback) {
                        callback(e);
                    }
                }
            );
        },
        async mixin_make_pic(node, size = 1) {
            let t1 = new Date().getTime();

            let html2canvas = (await import("html2canvas")).default;
            let t2 = new Date().getTime()
            console.log('t2:'+ (t2 - t1))

            let img_list = node.getElementsByTagName("img");
            let promise_list = [];
            for (let i = 0; i < img_list.length; i++) {
                console.log(img_list[i].src)
                promise_list.push(this.$img2base64(img_list[i]));
            }

            //start 处理背景含有 background-image
            let node_list = node.querySelectorAll('*'); 
            let srcChecker = /url\(\s*?['"]?\s*?(\S+?)\s*?["']?\s*?\)/i
            for (let j = 0; j < node_list.length; j++) {
              let prop = window.getComputedStyle(node_list[j], null).getPropertyValue('background-image')
              let match = srcChecker.exec(prop)
              if(match){
                promise_list.push(this.$img2base64(node_list[j], match[1]));
              }
            }
            //end 处理背景含有 background-image

            await Promise.all(promise_list);
            let t3 = new Date().getTime()
            console.log('t3:'+ (t3 - t2))

            let canvas = await html2canvas(node, {
                backgroundColor: "#fafafa",
                allowTaint: true,
                logging: false,
            });

            let img = this.$canvas2image.convertToJPEG(
                canvas,
                parseInt(canvas.style.width) * size,
                parseInt(canvas.style.height) * size
            );
            let t4 = new Date().getTime()
            console.log('t4:'+ (t4 - t3))

            return img;
        },
        $mixin_make_download(base64, filename) {
            var eleLink = document.createElement("a");
            eleLink.download = filename;
            eleLink.style.display = "none";
            eleLink.href = base64;
            document.body.appendChild(eleLink);
            eleLink.click();
            // 然后移除
            document.body.removeChild(eleLink);
        },
        $mixin_discount(n) {
            return (1000 * n) / 10;
        },
        $mixin_confirm(data) {
            return new Promise((resolve, reject) => {
              let btns = [{
                    title: data.cancel_text || this.$t('c.mixin_confirm.text1'),
                    handler: () => {
                        this.$modal.hide("dialog");
                        resolve(false);
                    },
                },
                {
                    title: data.submit_text || this.$t('c.mixin_confirm.text2'),
                    handler: async () => {
                        this.$modal.hide("dialog");
                        resolve(true);
                    },
                },
              ]
              if(data.is_hide_cancel){
                btns.shift(0)
              }
              this.$modal.show("dialog", {
                  title: data.title || this.$t('c.mixin_confirm.text3'),
                  buttons: btns
              });
            });
        },
        $mixin_waitting_api(api){
            return new Promise((resolve, reject) => {
                let go = setInterval(() => {
                    if (this.$http.is_run(api)){

                    }else{
                        clearInterval(go);
                        resolve(true);
                    }
                },10)
            })
        },
        $mixin_router_back(){
          if(!this.GL.ENV.is_afd_client){
            if(this.GL.ENV.is_ios){
              setTimeout(window.close, 301);//safari hack
              return false;
            }
            if(this.GL.ENV.is_android && window.history.length > 0){
              window.history.back();
              return false;
            }
          }
          if(this.GL.ENV.is_afd_client){
              this.$bridge.call("history_close", { }, e => {});
              return false;
          }
          if (this.$router.$from && this.$router.$from.name) {
            this.$router.go(-1);
          }else {
            this.$router.push("/");
          }
        },
        $mixin_router_push(path, is_href_blank, href = '', is_full_screen = '', plan = {}) {
            // let re = this.GL.ENV.is_afd_client && !this.GL.ENV.is_iPad;
            let re = (this.GL.ENV.is_afd_client && !this.GL.ENV.is_iPad) || (this.GL.ENV.is_iPad && this.GL.ENV.can_iPad_bridge);
            // let re = this.GL.ENV.is_afd_client;
            let url = href || `${this.host}${path}`;
            if(plan && this.$is_bundle_plan(plan)){
              url = url.replace('/item/','/bundle/')
              path = path.replace('/item/','/bundle/')
            }
            if (re) {
              this.$bridge.call("jumpToWebview", { url, is_full_screen: is_full_screen ? '1' : '' }, () => {
                  console.log("jumpToWebview success");
              });
              return false;
            }
            if(is_href_blank){
                window.open(url, '_blank');
                return false;
            }
            if(!path && href){
                location.href = href;
                return false;
            }
            this.$router.push(path);
        },
        $mixin_client_router(to) {
            // let re = this.GL.ENV.is_afd_client && !this.GL.ENV.is_iPad;
            let re = (this.GL.ENV.is_afd_client && !this.GL.ENV.is_iPad) || (this.GL.ENV.is_iPad && this.GL.ENV.can_iPad_bridge);
            // let re = this.GL.ENV.is_afd_client;
            let url = `${this.host}${to.fullPath}`;
            if (this.is_applying_apple) {
                if (url.indexOf("/order/create") != -1) {
                    return false;
                }
            }

            if (re) {
                this.$bridge.call("jumpToWebview", { url: url }, () => {
                    console.log("jumpToWebview success");
                });
            }
            return !re;
        },
        $mixin_show_modal_feed(config) {
            this.$modal.show(
                () => import("@/components/ModalFeed"),
                {
                    is_hide_close:config && config.is_hide_close ? true : false,
                    group_id: config && config.group_id ? config.group_id : "",
                    group: config && config.group ? config.group : {},
                    tit: config && config.tit ? config.tit : "",
                    is_hide_action:config && config.is_hide_action ? config.is_hide_action : false,
                    is_show_album: config && config.hasOwnProperty('is_show_album') ? config.is_show_album : true,
                },
                {
                    pivotY: this.browser_size == "small" ? 0.5 : 0.15,
                    clickToClose: false,
                    classes: "v--modal-feed v--modal",
                    height: this.browser_size == "small" ? "100%" : "auto",
                    width: this.browser_size == "small" ? "100%" : 1000,
                    adaptive: this.browser_size == "small" ? true : false,
                }
            );
        },
        $mixin_show_modal_select_month(list) {
            this.$modal.show(
                () => import("@/components/ModalSelectMonth"),
                {
                    list: list,
                },
                {
                    pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                    classes: "v--modal-select-month v--modal",
                    height: this.browser_size == "small" ? "100%" : "auto",
                    width: this.browser_size == "small" ? "100%" : 360,
                    adaptive: this.browser_size == "small" ? true : false,
                    scrollable: true,
                }
            );
        },
        $mixin_show_sheet_sale(data) {
          this.$modal.show(() => import("@/components/SheetSale"), data, {
              pivotY: this.browser_size == "small" ? 0.5 : 0.2,
              classes: "v--modal-sheet-sale v--modal",
              // height: this.browser_size == "small" ? "100%" : "auto",
              height: "auto",
              width: this.browser_size == "small" ? "100%" : 400,
              // adaptive: this.browser_size == "small" ? true : false,
              adaptive: false,
              scrollable: true,
          });
        },
        $mixin_show_sheet_plan_desc(data) {
          this.$modal.show(() => import("@/components/SheetPlanDesc"), data, {
              pivotY: this.browser_size == "small" ? 0.5 : 0.2,
              classes: "v--modal-sheet-sale v--modal",
              // height: this.browser_size == "small" ? "100%" : "auto",
              height: "auto",
              width: this.browser_size == "small" ? "100%" : 400,
              // adaptive: this.browser_size == "small" ? true : false,
              adaptive: false,
              scrollable: true,
          });
        },
        $mixin_show_modal_mass(data) {
            this.$modal.show(() => import("@/components/ModalMass"),data,{
                pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                clickToClose: false,
                classes: "v--modal-mass v--modal",
                height: this.browser_size == "small" ? "100%" : "auto",
                width: this.browser_size == "small" ? "100%" : 640,
                adaptive: this.browser_size == "small" ? true : false
                }
            );
        },
        $mixin_show_modal_mass_progress(data) {
            this.$modal.show(() => import("@/components/ModalMassProgress"),data,{
                pivotY: this.browser_size == "small" ? 0.4 : 0.4,
                clickToClose: false,
                classes: "v--modal-mass-progress v--modal",
                height: 150,
                width: 320,
                adaptive: this.browser_size == "small" ? true : false
                }
            );
        },
        $mixin_show_modal_wx_login(data) {
            this.$modal.show(() => import("@/components/ModalWxLogin"),data,{
                    // pivotY: this.browser_size == "small" ? 0.4 : 0.4,
                    clickToClose: true,
                    classes: "v--modal-wx-login v--modal",
                    height: 200,
                    width: '100%',
                    // adaptive: this.browser_size == "small" ? true : false,
                    name: "ModalWxLogin"
                }
            );
        },
        $mixin_show_modal_bundle_type(data) {
          this.$modal.show(() => import("@/components/ModalBundleType"),data,{
                  pivotY: this.browser_size == "small" ? 0.4 : 0.4,
                  clickToClose: true,
                  classes: "v--modal-bundle-type v--modal",
                  height: 'auto',
                  width: 320,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_bundle_pick(data) {
          this.$modal.show(() => import("@/components/ModalBundlePick"),data,{
                  pivotY: this.browser_size == "small" ? 0.4 : 0.4,
                  clickToClose: true,
                  classes: "v--modal-bundle-pick v--modal",
                  height: this.browser_size == "small" ? "100%" : "80%",
                  width: this.browser_size == "small" ? "100%" : 375,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_crm_filter(data) {
            this.$modal.show(() => import("@/components/ModalCrmFilter"),data,{
                pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                clickToClose: false,
                classes: "v--modal-crm-filter v--modal",
                height: this.browser_size == "small" ? "100%" : "auto",
                width: this.browser_size == "small" ? "100%" : 640,
                adaptive: this.browser_size == "small" ? true : false
                }
            );
        },
        $mixin_show_modal_vote(data) {
            this.$modal.show(() => import("@/components/ModalVote"),data,{
                pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                clickToClose: false,
                classes: "v--modal-vote v--modal",
                height: this.browser_size == "small" ? "100%" : "auto",
                width: this.browser_size == "small" ? "100%" : 640,
                adaptive: this.browser_size == "small" ? true : false
                }
            );
        },
        $mixin_show_modal_share_img(config) {
            this.$modal.show(
                () => import("@/components/ModalShareImg"),
                {
                    val: config.val ? config.val : location.href,
                    user: config.user,
                    post_id: config.post_id,
                    group: config.group || null,
                    album: config.album || null,
                    plan: config.plan || null,
                    badge: config.badge || null,
                    members: config.members || [],
                    sale_list: config.sale_list || [],
                    sku_list: config.sku_list || [],
                },
                {
                    pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                    classes: "v--modal-share-img v--modal",
                    //   height: this.browser_size == 'small' ? '100%' : 'auto',
                    height: "auto",
                    width: this.browser_size == "small" ? "100%" : 375,
                    adaptive: this.browser_size == "small" ? true : false,
                    scrollable: true,
                }
            );
        },
        $mixin_show_modal_album(config) {
            this.$modal.show(
                () => import("@/components/ModalAlbum"),
                {
                    album_id: config && config.album_id ? config.album_id : "",
                    post_count: config && config.post_count ? config.post_count : 0,
                    status: config && config.status ? config.status : "",
                    is_show_unlock: config && config.hasOwnProperty('is_show_unlock') ? config.is_show_unlock : true,
                    album: config && config.hasOwnProperty('album') ? config.album : null,
                },
                {
                    pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                    clickToClose: true,
                    classes: "v--modal-album v--modal",
                    height: this.browser_size == "small" ? "100%" : "auto",
                    width: this.browser_size == "small" ? "100%" : 375,
                    adaptive: this.browser_size == "small" ? true : false,
                }
            );
        },
        $mixin_show_modal_shop(config) {
          this.$modal.show(
              () => import("@/components/ModalShop"),
              {
                  list: config && config.hasOwnProperty('list') ? config.list : [],
              },
              {
                  pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                  clickToClose: false,
                  classes: "v--modal-shop v--modal",
                  height: this.browser_size == "small" ? "100%" : "auto",
                  width: this.browser_size == "small" ? "100%" : 375,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_album_pick(config) {
            this.$modal.show(
                () => import("@/components/ModalAlbumPick"),
                {
                    modal_id: config && config.modal_id ? config.modal_id : "",
                    user_id: config && config.user_id ? config.user_id : "",
                    sku_index: config && config.hasOwnProperty('sku_index') ? config.sku_index : '',
                    is_has_tip: config && config.hasOwnProperty('is_has_tip') ? config.is_has_tip : true,
                    is_checkbox: config && config.hasOwnProperty('is_checkbox') ? config.is_checkbox : false,
                    album_ids: config && config.hasOwnProperty('album_ids') ? config.album_ids : '',
                },
                {
                    pivotY: this.browser_size == "small" ? 0.5 : 0.2,
                    clickToClose: false,
                    classes: "v--modal-album-pick v--modal",
                    height: this.browser_size == "small" ? "100%" : "auto",
                    width: this.browser_size == "small" ? "100%" : 375,
                    adaptive: this.browser_size == "small" ? true : false,
                }
            );
        },
        $mixin_show_modal_express(config) {
          this.$modal.show(
              () => import("@/components/ModalExpress"),
              {
                  out_trade_no: config && config.hasOwnProperty('out_trade_no') ? config.out_trade_no : '',
                  express_no: config && config.hasOwnProperty('express_no') ? config.express_no : '',
                  express: config && config.hasOwnProperty('express') ? config.express : {},
              },
              {
                  pivotY: this.browser_size == "small" ? 0.4 : 0.2,
                  clickToClose: false,
                  classes: "v--modal-express v--modal",
                  height: "auto",
                  width: this.browser_size == "small" ? "100%" : 375,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_identity(data) {
          this.$modal.show(
              () => import("@/components/ModalIdentity"),data,{
                  pivotY: this.browser_size == "small" ? 0.3 : 0.2,
                  clickToClose: true,
                  classes: "v--modal-identity v--modal",
                  height: "auto",
                  width: this.browser_size == "small" ? "100%" : 375,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_address(config) {
          this.$modal.show(
              () => import("@/components/ModalAddress"),
              {
                  out_trade_no: config && config.hasOwnProperty('out_trade_no') ? config.out_trade_no : '',
                  addr_address: config && config.hasOwnProperty('addr_address') ? config.addr_address : '',
                  addr_name: config && config.hasOwnProperty('addr_name') ? config.addr_name : '',
                  addr_phone: config && config.hasOwnProperty('addr_phone') ? config.addr_phone : '',
                  is_need_save:config && config.hasOwnProperty('is_need_save') ? config.is_need_save : true,
                  tip_text:config && config.hasOwnProperty('tip_text') ? config.tip_text : '',
              },
              {
                  pivotY: this.browser_size == "small" ? 0.4 : 0.2,
                  clickToClose: false,
                  classes: "v--modal-express v--modal",
                  height: "auto",
                  width: 343,
                  adaptive: this.browser_size == "small" ? true : false,
              }
          );
        },
        $mixin_show_modal_textarea(config) {
            this.$modal.show(
                () => import("@/components/ModalTextarea"),
                {
                    content: config && config.hasOwnProperty('content') ? config.content : '',
                    title: config && config.hasOwnProperty('title') ? config.title : '',
                    placeholder: config && config.hasOwnProperty('placeholder') ? config.placeholder : '',
                    modal_id: config && config.hasOwnProperty('modal_id') ? config.modal_id : '',
                    param: config && config.hasOwnProperty('param') ? config.param : {},
                    submit_text: config && config.hasOwnProperty('submit_text') ? config.submit_text : '',
                },
                {
                    pivotY: this.browser_size == "small" ? 0.4 : 0.2,
                    clickToClose: false,
                    classes: "v--modal-textarea v--modal",
                    height: "auto",
                    width: 343,
                    adaptive: this.browser_size == "small" ? true : false,
                }
            );
        },
        $mixin_show_modal_price(config) {
            this.$modal.show(
                () => import("@/components/ModalPrice"),
                {
                    content: config && config.hasOwnProperty('content') ? config.content : '',
                    title: config && config.hasOwnProperty('title') ? config.title : '',
                    placeholder: config && config.hasOwnProperty('placeholder') ? config.placeholder : '',
                    modal_id: config && config.hasOwnProperty('modal_id') ? config.modal_id : '',
                },
                {
                    pivotY: this.browser_size == "small" ? 0.4 : 0.2,
                    clickToClose: false,
                    classes: "v--modal-price v--modal",
                    height: 162,
                    width: 343,
                    adaptive: this.browser_size == "small" ? true : false,
                }
            );
        },
        $mixin_share(share_config){
            if (this.GL.ENV.is_afd_client) {
                window.app_call_share = () => {
                    this.$bridge.call("share", share_config, () => {});
                };
            }
            if(this.GL.ENV.is_wechat){
                this.$wx_jssdk_ready(share_config.url,() => {
                    if(share_config.wx_description){
                      share_config.description = share_config.wx_description;
                    }
                    if(share_config.wx_pic){
                      share_config.pic = share_config.wx_pic;
                    }
                    this.$wx_share(share_config)
                })
            }
        },
        $mixin_open_app(){
            if(this.GL.ENV.is_weibo && this.GL.ENV.is_ios){
                this.$router.push(`/app?origin_url=${location.href}`);
                return false;
            }

            let url = location.href;
            let type = '1';
            let r = this.$route;
            if(r.name == 'index' || r.name == 'feed'){
                url = '/feed'
                type = '2'
            }
            if(r.name == 'explore'){
                url = '/explore'
                type = '2'
            }
            if(r.name == 'message'){
                url = '/message'
                type = '2'
            }
            if(r.name == 'dashboardStats'){
                url = '/dashboard'
                type = '2'
            }
            // if(r.name == 'testxxx'){
            //   url = `${this.GL.ENV.applink_host}${location.pathname}${location.search}`
            // }
            // if(this.GL.ENV)
            this.$call_app({
                param: {
                    params:JSON.stringify({
                        "url": url,
                        'type':type
                    })
                },
                path: 'app/openapp',
            })
        },
        $mixin_show_modal_img(
            index,
            pics,
            top = "",
            tip = "",
            is_client_preview = true,
            can_copy_pic = true,
            watermark = 1,
            watermark_text = ''
        ) {
            if(watermark > 1){
                let list = [];
                for(let i = 0; i < pics.length; i++){
                    list.push(this.$img_src({
                        src: pics[i],
                        watermark:watermark,
                        watermark_text: watermark_text,
                    }))
                }
                pics = list;
            }
            if (
                is_client_preview &&
                this.GL.ENV.is_afd_client &&
                (this.GL.ENV.is_android || (this.GL.ENV.is_ios && app_version("1.3.33") == "higher")) &&
                // this.GL.ENV.is_android &&
                can_copy_pic
            ) {
                this.$bridge.call("imagePreview",{
                    urls: pics,
                    current: pics[index],
                },() => {});
                return false;
            }
            if (this.GL.ENV.is_wechat && typeof WeixinJSBridge != "undefined" && can_copy_pic) {
                WeixinJSBridge.invoke("imagePreview", {
                    urls: pics,
                    current: pics[index],
                });
                return false;
            }
            this.$modal.show(
                () => import("@/components/ModalImg"),
                {
                    // src:src,
                    src_list: pics,
                    top: top,
                    tip: tip,
                    swiper_config: {
                        initialSlide: index,
                    },
                    can_copy_pic,
                    width: "screen",
                    height: "screen",
                },
                {
                    classes: "v--modal-img v--modal",
                    height: "100%",
                    width: "100%",
                }
            );
        },
    },
};
